import { Button } from "src/components/ui-components/Button/Button";
import { ProgressPieChart } from "../ProgressPieChart/ProgressPieChart";
import { CompletedIcon } from "./CompletedIcon";
import { useEffect, useRef, useState } from "react";
import styles from "./GetStartedButton.module.css";
import cn from "classnames";

interface Props {
  percentage: number;
}

export function GetStartedButton(props: Props) {
  const { percentage } = props;
  const [isJiggling, setIsJiggling] = useState(false);
  const initialPercentageRef = useRef(percentage);

  useEffect(() => {
    if (initialPercentageRef.current !== percentage && percentage !== 100) {
      setIsJiggling(true);
      // Set timeout for the duration of the jiggle animation
      const timer = setTimeout(() => {
        setIsJiggling(false);
      }, 500); // Assuming the jiggle lasts for 500 milliseconds
      return () => clearTimeout(timer);
    }
  }, [percentage]);

  return (
    <Button
      className={cn([
        styles.gettingStartedButton,
        isJiggling && styles.jiggling,
      ])}
      size="M"
      theme="green"
    >
      <>
        {percentage < 100 ? (
          <ProgressPieChart percentage={percentage} />
        ) : (
          <CompletedIcon />
        )}
        Get Started
      </>
    </Button>
  );
}
